(() => {
  if (customElements.get('load-more')) {
    return;
  }

  class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.loadMoreButton = this.querySelector('[data-trigger]');
      this.nextPageUrl = this.dataset.next;
      this.sectionId = this.dataset.sectionId;

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', () => this.fetchMoreItems());
      }
    }

    fetchMoreItems() {
      if (!this.nextPageUrl) {
        this.loadMoreButton.style.display = 'none';
        return;
      }

      let fullUrl = new URL(window.location.origin + this.nextPageUrl);
      fullUrl.searchParams.set('section_id', this.sectionId);

      fetch(fullUrl)
        .then(response => response.text())
        .then(text => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(text, 'text/html');

          const newProducts = newDocument.querySelectorAll('#product-grid .grid__item');
          const productGrid = document.querySelector('#product-grid');

          if (newProducts.length > 0 && productGrid) {
            newProducts.forEach(item => productGrid.appendChild(item));

            if (window.yotpo) {
              window.yotpo.refreshWidgets();
            }
          }

          const newLoadMore = newDocument.querySelector('[data-load-more] load-more');
          if (newLoadMore) {
            this.setAttribute('data-next', newLoadMore.getAttribute('data-next'));
            this.nextPageUrl = newLoadMore.getAttribute('data-next');
          } else {
            this.remove();
          }
        })
        .catch(error => console.error('Error loading more products:', error));
    }
  }

  customElements.define('load-more', LoadMore);
})();
